import React, { useState, useEffect, useLayoutEffect } from "react";
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { HeaderButton } from "components";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Buttons } from "components";
import { ACTIONS } from "consts/Actions";
import { DepartamentoTitles as titles } from "consts/titulos-de-tablas";
import styles from "styles/pages/Pages.module.scss";
import { useService, puedeEditarServicio } from "components/route/ServiceRoute";
import XGrid from "components/UI/Grid/XGrid";
import { RNHDepartamentoGet } from "services/services-mia/programa-salud/estructuras/RNHDepartamentoGet";
import { etiquetaSiNo } from "consts/banderas";

export default function Departamentos() {
    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);
    const [modalDetails, setModalDetails] = useState({ isOpen: false });
    const [loading, setLoading] = useState(false);
    const [departamentos, setDepartamentos] = useState([]);
    const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
    const { service } = useService();

    const getDepartamentos = async () => {
        setDepartamentos([]);
        setRowSelected({ status: false, row: {} });
        setLoading(true);
        const { data: result } = await RNHDepartamentoGet(credentials);
        const newRows = result[0]?.rnhDepartamentoId ? result?.map((data) => {
            return {
                id: data.rnhDepartamentoId,
                cod: data.rnhDepartamentoCod,
                name: data.rnhDepartamentoNombre,
                desc: data.rnhDepartamentoDescripcion,

              // Los dos permisos. Las claves son las de los PARAMS, que es lo que nos
              // confirmaron; falta ver una response real para saber si las devuelve con el
              // mismo nombre. Hasta entonces dan `undefined` y las columnas van vacias, que
              // es justo lo que queremos mientras el dato no exista.
              //
              // Se guardan las dos formas del mismo dato, como hace el detalle del agente
              // con `status` y `statusCod`: la ETIQUETA para la celda y el CRUDO "Y"/"N"
              // para precargar el modal de edicion.
              rotativos: etiquetaSiNo(data.rnhDepartamentoAdmiteRotativos),
              guardias: etiquetaSiNo(data.rnhDepartamentoAdmiteGuardias),
              admiteRotativos: data.rnhDepartamentoAdmiteRotativos,
              admiteGuardias: data.rnhDepartamentoAdmiteGuardias,

              // No son columnas: viajan en la fila para que Modificar y Eliminar no
              // tengan que volver a pedir el registro.
              version: data.rnhDepartamentoVersion,
            };
        }) : []
        setDepartamentos(newRows);
        setLoading(false);
    }
    const closeModal = () => {
        setModalDetails({ isOpen: false });
    };
    const handleClick = ({ procede, title }) => {
        setModalDetails({ procede, title, isOpen: true });
    };

    useEffect(() => {
        getDepartamentos()
    }, [])
    useLayoutEffect(() => {
        setRoute({
            wordKey: `Departamentos - Programa Salud RN`
        })
    }, [service.servicioNombre, setRoute])

    return (
        <main className={styles.main}>
            <Modal size={modalDetails.procede === ACTIONS.DELETE ? 'sm' : 'md'} open={modalDetails.isOpen} title={modalDetails.title} onClose={closeModal}>
                {modalDetails.procede === ACTIONS.UPDATE && (
                    <UpdateModal
                        row={rowSelected.row}
                        updateList={getDepartamentos}
                        closeModal={closeModal}
                    />
                )}
                {modalDetails.procede === ACTIONS.DELETE && (
                    <DeleteModal
                        row={rowSelected.row}
                        servicio={service}
                        updateList={getDepartamentos}
                        closeModal={closeModal}
                        setterRowSelected={setRowSelected}
                    />
                )}
                {modalDetails.procede === ACTIONS.INSERT && (
                    <InsertModal
                        servicio={service}
                        updateList={getDepartamentos}
                        closeModal={closeModal}
                    />
                )}
            </Modal>
            <div className={styles["filters-actions-right"]}>
                <Buttons>
                    <HeaderButton
                        text={"Actualizar"}
                        onClick={() => { getDepartamentos() }}
                        disabled={rowSelected.row.id || false}
                    >
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text={"Nuevo Departamento"}
                        handleClick={handleClick}
                        data={{
                            title: "Nuevo Departamento",
                            procede: ACTIONS.INSERT
                        }}
                        disabled={rowSelected.row.id || service.servicioPermiso !== 'E'}
                    >
                        <Add />
                    </HeaderButton>
                    <HeaderButton
                        text={"Modificar Departamento"}
                        handleClick={handleClick}
                        data={{
                            title: "Modificar Departamento",
                            procede: ACTIONS.UPDATE
                        }}
                        disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
                    >
                        <EditOutlined />
                    </HeaderButton>
                    <HeaderButton
                        text={"Eliminar Departamento"}
                        handleClick={handleClick}
                        data={{
                            title: "Eliminar Departamento",
                            procede: ACTIONS.DELETE
                        }}
                        disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
                    >
                        <DeleteOutlineRoundedIcon />
                    </HeaderButton>
                </Buttons>
            </div>
            <div className={styles.container}>
                <XGrid
                    rows={departamentos}
                    titles={titles}
                    loading={loading}
                    secondarySelected={rowSelected}
                    setSecondarySelected={setRowSelected}
                />
            </div>
        </main>
    );
}